import { useTranslation } from 'react-i18next';

const AllToolsSection = () => {
  const { t } = useTranslation();

  const tools = [
    {
      icon: 'ri-file-word-line',
      name: t('home:tools.pdfToWord.name'),
      description: t('home:tools.pdfToWord.description'),
      link: '/pdf-to-word',
      bgColor: 'bg-teal-50',
      iconColor: 'text-teal-600',
      btnColor: 'bg-teal-600 hover:bg-teal-700',
    },
    {
      icon: 'ri-file-excel-line',
      name: t('home:tools.pdfToExcel.name'),
      description: t('home:tools.pdfToExcel.description'),
      link: '/pdf-to-excel',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-600',
      btnColor: 'bg-green-600 hover:bg-green-700',
    },
    {
      icon: 'ri-file-ppt-line',
      name: t('home:tools.pdfToPpt.name'),
      description: t('home:tools.pdfToPpt.description'),
      link: '/pdf-to-ppt',
      bgColor: 'bg-orange-50',
      iconColor: 'text-orange-600',
      btnColor: 'bg-orange-600 hover:bg-orange-700',
    },
    {
      icon: 'ri-image-line',
      name: t('home:tools.pdfToImage.name'),
      description: t('home:tools.pdfToImage.description'),
      link: '/image-convert',
      bgColor: 'bg-pink-50',
      iconColor: 'text-pink-600',
      btnColor: 'bg-pink-600 hover:bg-pink-700',
    },
    {
      icon: 'ri-file-pdf-line',
      name: t('home:tools.imageToPdf.name'),
      description: t('home:tools.imageToPdf.description'),
      link: '/image-convert',
      bgColor: 'bg-red-50',
      iconColor: 'text-red-600',
      btnColor: 'bg-red-600 hover:bg-red-700',
    },
    {
      icon: 'ri-merge-cells-horizontal',
      name: t('home:tools.mergePdf.name'),
      description: t('home:tools.mergePdf.description'),
      link: '/pdf-tools',
      bgColor: 'bg-indigo-50',
      iconColor: 'text-indigo-600',
      btnColor: 'bg-indigo-600 hover:bg-indigo-700',
    },
    {
      icon: 'ri-scissors-cut-line',
      name: t('home:tools.splitPdf.name'),
      description: t('home:tools.splitPdf.description'),
      link: '/pdf-tools',
      bgColor: 'bg-yellow-50',
      iconColor: 'text-yellow-600',
      btnColor: 'bg-yellow-500 hover:bg-yellow-600',
    },
    {
      icon: 'ri-compasses-2-line',
      name: t('home:tools.compressPdf.name'),
      description: t('home:tools.compressPdf.description'),
      link: '/pdf-tools',
      bgColor: 'bg-teal-50',
      iconColor: 'text-teal-600',
      btnColor: 'bg-teal-600 hover:bg-teal-700',
    }
  ];

  return (
    <section id="tools" className="py-20 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('home:allTools.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('home:allTools.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {tools.map((tool, index) => (
            <a
              key={index}
              href={tool.link}
              className="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer flex flex-col"
            >
              <div className="p-6 flex flex-col flex-1">
                <div className={`w-14 h-14 ${tool.bgColor} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform flex-shrink-0`}>
                  <i className={`${tool.icon} text-2xl ${tool.iconColor}`}></i>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{tool.name}</h3>
                <p className="text-gray-500 text-sm leading-relaxed flex-1">{tool.description}</p>
                <div className="mt-5">
                  <span className={`inline-block w-full text-center px-4 py-2 ${tool.btnColor} text-white text-sm font-semibold rounded-lg transition-colors whitespace-nowrap`}>
                    {t('home:allTools.tryNow')}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="w-full h-24 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-white">
          <span className="text-gray-400 text-sm">{t('home:ads.middleBanner')} 728×90</span>
        </div>
      </div>
    </section>
  );
};

export default AllToolsSection;
